/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getAccessTierDecoder,
  getAccessTierEncoder,
  type AccessTier,
  type AccessTierArgs,
} from ".";

export type TierUpdatedEvent = {
  agent: Address;
  oldTier: AccessTier;
  newTier: AccessTier;
  totalStaked: bigint;
  dailyApiCalls: number;
  votingPower: bigint;
};

export type TierUpdatedEventArgs = {
  agent: Address;
  oldTier: AccessTierArgs;
  newTier: AccessTierArgs;
  totalStaked: number | bigint;
  dailyApiCalls: number;
  votingPower: number | bigint;
};

export function getTierUpdatedEventEncoder(): FixedSizeEncoder<TierUpdatedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["oldTier", getAccessTierEncoder()],
    ["newTier", getAccessTierEncoder()],
    ["totalStaked", getU64Encoder()],
    ["dailyApiCalls", getU32Encoder()],
    ["votingPower", getU64Encoder()],
  ]);
}

export function getTierUpdatedEventDecoder(): FixedSizeDecoder<TierUpdatedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["oldTier", getAccessTierDecoder()],
    ["newTier", getAccessTierDecoder()],
    ["totalStaked", getU64Decoder()],
    ["dailyApiCalls", getU32Decoder()],
    ["votingPower", getU64Decoder()],
  ]);
}

export function getTierUpdatedEventCodec(): FixedSizeCodec<
  TierUpdatedEventArgs,
  TierUpdatedEvent
> {
  return combineCodec(
    getTierUpdatedEventEncoder(),
    getTierUpdatedEventDecoder(),
  );
}
